export default __webpack_public_path__ + "static/media/W_A_True.fb59ea9e.jpg";